"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NewsDetailController = /*#__PURE__*/function (_PageController) {
  _inherits(NewsDetailController, _PageController);

  var _super = _createSuper(NewsDetailController);

  function NewsDetailController() {
    var _this2;

    _classCallCheck(this, NewsDetailController);

    _this2 = _super.call(this);
    _this2.imageCompilation = ".mceWrapper-imgCompilation";
    _this2.imageCompilationItem = ".wrapperImgCompilation-item";
    _this2.mceImage = ".mceImage";

    if (_this2.platform.isPhone() || _this2.platform.isTablet()) {
      _this2.initAnchorScroll(40);
    } else {
      _this2.initAnchorScroll(40);
    }

    _this2.initImageCompilation();

    _this2.initImagesLink();

    _this2.showFormPopover();

    return _this2;
  }

  _createClass(NewsDetailController, [{
    key: "initImagesLink",
    value: function initImagesLink() {
      var _this = this;

      $(_this.mceImage).each(function () {
        if ($(this).parents("a").length == 0) {
          $(this).wrap('<a href="' + $(this).attr('src') + '" data-lightbox="image-1" ></a>');
        }
      });
    }
  }, {
    key: "showFormPopover",
    value: function showFormPopover() {
      $(document).on('click', '.showFormPopoverContact', function (e) {
        $('#formPopoverContact').modal();
        return false;
      });
      $(document).on('click', '.showFormPopoverMessage', function (e) {
        $('#formPopoverMessage').modal();
        return false;
      });
      $(document).on('click', '.showFormPopoverSubscribe', function (e) {
        console.log($(this).attr('data-mailchimp-tag'));
        $('#formPopoverSubscribe').modal();
        return false;
      });
    }
  }, {
    key: "initImageCompilation",
    value: function initImageCompilation() {
      console.log('init');

      var _this = this;

      _this.recalculateImageCompilation();

      $(window).resize(function () {
        $(_this.imageCompilationItem, $(_this.imageCompilation)).attr('style', '');
        $("img", $(_this.imageCompilation)).attr('style', '');

        _this.recalculateImageCompilation();
      });
    }
  }, {
    key: "recalculateImageCompilation",
    value: function recalculateImageCompilation() {
      var _this = this;

      var maxHeight = false;

      if (this.platform.isPhone()) {
        return false;
      } //recalculate optimal width


      $(_this.imageCompilation).each(function () {
        $("img", this).each(function () {
          var width = $(this).parents(_this.imageCompilationItem).width();
          $(this).attr('style', 'width: ' + width + 'px !important');
          $(this).parent(_this.imageCompilationItem).css('height', $(this).height());
        });
      }); //recalculate optimal height

      $(_this.imageCompilation).each(function () {
        maxHeight = false;
        $("img", this).each(function () {
          maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });
        $("img", this).each(function () {
          $(this).parents(_this.imageCompilationItem).css('height', maxHeight);
          var styles = 'min-height: ' + maxHeight + 'px !important; max-height: ' + maxHeight + 'px !important;';
          $(this).attr('style', styles);
        });
      });
    }
  }]);

  return NewsDetailController;
}(PageController);